import Box from '@mui/material/Box';
import Link from 'next/link';

import { OptionMenuItemProps } from '../props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const OptionMenuItem: React.FC<OptionMenuItemProps> = (props) => {
  const { children, option } = props;

  // =============== VIEWS
  if (!option.href) {
    return <>{children}</>;
  }

  return (
    <Box
      component={Link}
      href={option.href}
      {...option.linkProps}
      sx={{
        px: 4,
        py: 1.5,
        width: '100%',
        display: 'flex',
        color: 'inherit',
        alignItems: 'center',
        textDecoration: 'none',
      }}
    >
      {children}
    </Box>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default OptionMenuItem;
